const componentSerializationKey = 'CustomizedSlidingDoorComponent';
export class CustomizedSlidingDoorComponentSerializer {
    constructor() {
        this.thisClassIsGuaranteedToNotModifyOrQueryCoreState = true;
    }
    canHandle(serializationKey) {
        return serializationKey === componentSerializationKey;
    }
    deserialize(serializationKey, json) {
        const data = JSON.parse(json.toString());
        switch (serializationKey) {
            case componentSerializationKey:
                return new CustomizedSlidingDoorComponent(data.panelArrangement);
        }
        return null;
    }
}
class CustomizedSlidingDoorComponent {
    constructor(panelArrangement) {
        this.typeId = CustomizedSlidingDoorComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = true;
        this.panelArrangement = panelArrangement;
    }
    eq() {
        return false;
    }
    toJson(parse) {
        return parse(JSON.stringify(this));
    }
    serializationKey() {
        return componentSerializationKey;
    }
}
CustomizedSlidingDoorComponent.id = 2020; // Note that this Id is save to VPC and should not be changed
export default CustomizedSlidingDoorComponent;
//# sourceMappingURL=CustomizedSlidingDoorComponent.js.map